import { useEffect, useState } from "react";

/**
 * Returns the current time formatted as "06 May 2026, 04:41 pm" and updates
 * every 30 seconds — minute resolution stays accurate without thrashing
 * renders. Mark the consuming container `aria-hidden` (decorative).
 */
export function useNowFormatted(): string {
  const [now, setNow] = useState<Date>(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(now);
}
